import { AnyAction } from 'redux';
import { useDispatch } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';

import type { StoreState } from '../../types/store';

export const useThunkDispatch = () => useDispatch<ThunkDispatch<StoreState, unknown, AnyAction>>();
